{
  "REGISTER": {
    "TRY_WOOT": "Create an account",
    "TITLE": "Registrer",
    "TESTIMONIAL_HEADER": "All it takes is one step to move forward",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "By creating an account, you agree to our <a href=\"https://chat.jarabot.com/terms\">T & C</a> and <a href=\"https://chat.jarabot.com/privacy-policy\">Privacy policy</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Vilkår og betingelser</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Personvernerklæring</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Company name",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Fullt navn",
      "PLACEHOLDER": "Skriv inn fullt navn. F. eks: Ola Nordmann",
      "ERROR": "Kontonavnet er for kort"
    },
    "EMAIL": {
      "LABEL": "Bedriftse-postadresse",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Passord",
      "PLACEHOLDER": "Passord",
      "ERROR": "Passordet er for kort",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bekreft passord",
      "PLACEHOLDER": "Bekreft passord",
      "ERROR": "Passordet stemmer ikke"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registrering fullført",
      "ERROR_MESSAGE": "Kunne ikke koble til Woot Server, vennligst prøv igjen senere"
    },
    "SUBMIT": "Create account",
    "HAVE_AN_ACCOUNT": "Har du allerede en konto?"
  }
}
